<template>
  <div class="vue-select-county-dropdown-wrap">
    <div>
        <select @change="onCountySelectChange($event)" name="utilites">
          <option v-for="county in countiesForDropdown" v-bind:selected="county.selected" :key="county.countyId" :value="county.countyId">{{county.name}}</option>
        </select>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';

export default {
  name: 'SelectCountyDropdown',
  props: {
      counties: Array,
      countySelected: Function
  },
  data() {
    return {
      placeholderCountyId: 999,
      countiesForDropdown: undefined
    }
  },
  async created() {
    this.processCountiesForDropdown(this.counties);
  },
  watch: {
    counties: function (counties) {
      this.processCountiesForDropdown(counties);
    }
  },
  methods: {
    onCountySelectChange(event) {
      const countyId = parseInt(event.target.value, 10);
      const matchingCounty = lodash.find(this.countiesForDropdown, county => county.countyId === countyId);
      if (matchingCounty.countyId === this.placeholderCountyId) {return; }
      this.countySelected(matchingCounty);
    },
    processCountiesForDropdown(counties) {
      this.countiesForDropdown = JSON.parse(JSON.stringify(counties));

      this.countiesForDropdown.unshift({
        countyId: this.placeholderCountyId,
        name: 'Please select a county',
        selected: true
      });
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
